import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SisRadioOption {
  label: string;
  value: string;
  disabled?: boolean;
}

let sisRadioId = 0;

@Component({
  selector: 'app-sis-radio-group',
  templateUrl: './sis-radio-group.component.html',
  styleUrls: ['./sis-radio-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SisRadioGroupComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SisRadioGroupComponent implements ControlValueAccessor {
  @Input() legend = '';
  @Input() options: SisRadioOption[] = [];
  @Input() inline = true;

  readonly name = `sis-radio-${++sisRadioId}`;
  value = '';
  disabled = false;

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.value = value == null ? '' : String(value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
